export const PREGUNTA_SALUD_EVOLUCIONA = Object.freeze({
    CIRUGIAS: '¿Te han realizado tratamientos médicos o cirugías a causa de alguna enfermedad o accidente?',
    EMBARAZO: '¿Te encuentras en estado de gestación?'
});
